import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export type AuditEvent = {
  id: string;
  event_type: string;
  actor_id: string | null;
  driver_id: string | null;
  plate: string | null;
  metadata: Record<string, unknown>;
  created_at: string;
};

export function useAuditEvents(limit = 50) {
  const [events, setEvents] = useState<AuditEvent[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    const { data, error: err } = await supabase.rpc('list_audit_events', { p_limit: limit });
    if (err) {
      setError(err.message);
      setEvents([]);
    } else {
      setEvents((data as AuditEvent[]) ?? []);
    }
    setLoading(false);
  }, [limit]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { events, loading, error, refetch };
}
